import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        camerasList: [],
        companyBankObj: {}
    },
    getters: {
        getCamerasList (state) {
            return state.camerasList
        },
        getCompanyBankObj(state) {
            return state.companyBankObj
        }
    },
    mutations: {
        SaveCamerasList (state, val) {
            state.camerasList = val
        },
        SetCompanyBankObj(state, val) {
            state.companyBankObj = val
        }
    },
    actions: {
        saveCamerasList({commit}, val){
            commit("SaveCamerasList", val)
        },
    },
    modules: {
    }
})
